import React, { Component, Suspense } from "react"
import { HashRouter } from "react-router-dom"
import { renderRoutes } from "react-router-config"
import { Spin } from 'antd'
import routes from "../router/routes"
import { AuthRoute } from "../components"

class Router extends Component<any> {
	render() {
		return (
			<HashRouter>
				<Suspense fallback={<Spin size="large"></Spin>}>
					<AuthRoute routes={routes}>{renderRoutes(routes)}</AuthRoute>
				</Suspense>
			</HashRouter>
		)
	}
}

export default Router
